import _ from 'lodash';
import { bindActionCreators } from '@reduxjs/toolkit';
import * as appActions from '../../actions';

export const bindDispatch = _.memoize((dispatch) => ({
  dispatch,
  actions: bindActionCreators(appActions, dispatch),
}));
